export const UPDATE_POLIZZA    = 'UPDATE_POLIZZA';